export default __webpack_public_path__ + "static/bathrooms-10e88ca8248b6c72d7e0b9a41f62695a.jpeg";